var _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g, _g2, _ellipse, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 127,
    viewBox: "0 0 86 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 84.5,
    height: 126.5,
    rx: 1.75,
    stroke: "#C0C0C0",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7471 103H25.4401C25.5721 103 25.6601 102.912 25.6931 102.835C25.9131 102.329 26.1441 101.834 26.3641 101.328H29.9611L30.6431 102.835C30.6871 102.934 30.7641 103 30.8961 103H31.5891C31.7541 103 31.8421 102.857 31.7761 102.714L28.4211 95.311C28.3881 95.245 28.2891 95.19 28.2341 95.19H28.1241C28.0691 95.19 27.9701 95.245 27.9371 95.311L24.5601 102.714C24.4941 102.857 24.5821 103 24.7471 103ZM26.7931 100.382L28.1351 97.368H28.1901L29.5431 100.382H26.7931ZM32.8231 102.791C32.8231 102.901 32.9221 103 33.0321 103H33.6041C33.7911 103 33.8571 102.934 33.8571 102.791V100.107C33.9121 99.953 34.3851 99.447 35.0781 99.447C35.6501 99.447 35.9911 99.832 35.9911 100.536V102.791C35.9911 102.901 36.0791 103 36.2001 103H36.8271C36.9371 103 37.0361 102.901 37.0361 102.791V100.58C37.0361 99.436 36.5411 98.49 35.1991 98.49C34.3191 98.49 33.7361 99.018 33.6591 99.106L33.5271 98.732C33.5051 98.655 33.4391 98.6 33.3511 98.6H33.0321C32.9221 98.6 32.8231 98.699 32.8231 98.809V102.791ZM38.42 100.8C38.42 102.065 39.311 103.11 40.477 103.11C41.346 103.11 41.874 102.494 41.874 102.494L41.962 102.813C41.995 102.923 42.061 103 42.16 103H42.49C42.6 103 42.699 102.901 42.699 102.791V95.509C42.699 95.399 42.6 95.3 42.49 95.3H41.852C41.742 95.3 41.643 95.399 41.643 95.509V98.732C41.544 98.699 41.148 98.49 40.587 98.49C39.366 98.49 38.42 99.513 38.42 100.8ZM39.443 100.8C39.443 100.052 39.96 99.447 40.697 99.447C41.269 99.447 41.654 99.711 41.654 99.711V101.504C41.599 101.625 41.28 102.164 40.609 102.164C39.905 102.164 39.443 101.537 39.443 100.8ZM44.4616 102.791C44.4616 102.901 44.5606 103 44.6706 103H45.1986C45.3746 103 45.4956 102.978 45.4956 102.791V99.997C45.5396 99.92 45.8476 99.458 46.4856 99.458C46.6286 99.458 46.7936 99.502 46.8596 99.535C46.9586 99.579 47.0686 99.557 47.1236 99.436L47.3876 98.897C47.5086 98.6 47.0026 98.49 46.5846 98.49C45.7816 98.49 45.3746 99.018 45.2976 99.128L45.1766 98.754C45.1546 98.666 45.0666 98.6 44.9896 98.6H44.6706C44.5606 98.6 44.4616 98.699 44.4616 98.809V102.791ZM48.1247 100.789C48.1247 102.054 49.1147 103.11 50.3467 103.11C51.5787 103.11 52.5687 102.054 52.5687 100.789C52.5687 99.546 51.5787 98.49 50.3467 98.49C49.1147 98.49 48.1247 99.546 48.1247 100.789ZM49.1037 100.789C49.1037 100.052 49.6537 99.447 50.3467 99.447C51.0397 99.447 51.5897 100.052 51.5897 100.789C51.5897 101.548 51.0397 102.164 50.3467 102.164C49.6537 102.164 49.1037 101.548 49.1037 100.789ZM54.5006 96.807C54.8636 96.807 55.1496 96.521 55.1496 96.169C55.1496 95.806 54.8636 95.52 54.5006 95.52C54.1486 95.52 53.8736 95.806 53.8736 96.169C53.8736 96.521 54.1486 96.807 54.5006 96.807ZM53.9946 102.791C53.9946 102.901 54.0936 103 54.2036 103H54.8306C54.9406 103 55.0396 102.901 55.0396 102.791V98.809C55.0396 98.699 54.9406 98.6 54.8306 98.6H54.2036C54.0936 98.6 53.9946 98.699 53.9946 98.809V102.791ZM56.4763 100.8C56.4763 102.065 57.3673 103.11 58.5333 103.11C59.4023 103.11 59.9303 102.494 59.9303 102.494L60.0183 102.813C60.0513 102.923 60.1173 103 60.2163 103H60.5463C60.6563 103 60.7553 102.901 60.7553 102.791V95.509C60.7553 95.399 60.6563 95.3 60.5463 95.3H59.9083C59.7983 95.3 59.6993 95.399 59.6993 95.509V98.732C59.6003 98.699 59.2043 98.49 58.6433 98.49C57.4223 98.49 56.4763 99.513 56.4763 100.8ZM57.4993 100.8C57.4993 100.052 58.0163 99.447 58.7533 99.447C59.3253 99.447 59.7103 99.711 59.7103 99.711V101.504C59.6553 101.625 59.3363 102.164 58.6653 102.164C57.9613 102.164 57.4993 101.537 57.4993 100.8Z",
    fill: "#2E2E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8013 31.9919V31.9919C59.9111 31.9919 60.0001 32.081 60.0001 32.1908V37.363C60.0001 37.4728 59.9111 37.5618 59.8013 37.5618V37.5618V31.9919Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8013 41.3413V41.3413C59.9111 41.3413 60.0001 41.4303 60.0001 41.5402V51.4865C60.0001 51.5964 59.9111 51.6854 59.8013 51.6854V51.6854V41.3413Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9658,
    y: 12,
    width: 22.8693,
    height: 0.696237,
    fill: "black",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9658,
    y: 85.3037,
    width: 22.8693,
    height: 0.696236,
    fill: "black",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 80.0322,
    width: 62.0645,
    height: 0.696025,
    transform: "rotate(-90 25 80.0322)",
    fill: "black",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 59.8013,
    y: 17.9678,
    width: 62.0645,
    height: 0.696026,
    transform: "rotate(90 59.8013 17.9678)",
    fill: "black",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9659 85.3039C28.0829 85.3039 25.696 82.9163 25.696 80.0324H25C25 83.3008 27.6985 86.0001 30.9659 86.0001V85.3039Z",
    fill: "black",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0839 84.2772C28.2563 85.4556 29.5957 85.9006 30.966 85.9006V85.5028C29.2775 85.5028 27.9283 84.7178 27.1817 84.1733C26.9133 83.9776 26.8496 84.0418 27.0839 84.2772Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4741 83.6025C25.4682 82.4527 25.0996 81.0935 25.0996 80.0324L25.5498 80.0324C25.5498 81.5795 26.1395 82.7937 26.5887 83.5056C26.77 83.793 26.6978 83.8582 26.4741 83.6025Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8354 85.3039C56.7184 85.3039 59.1052 82.9163 59.1052 80.0324H59.8013C59.8013 83.3008 57.1028 86.0001 53.8354 86.0001V85.3039Z",
    fill: "black",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7174 84.2772C56.545 85.4556 55.2055 85.9006 53.8353 85.9006V85.5028C55.5238 85.5028 56.873 84.7178 57.6196 84.1733C57.888 83.9776 57.9517 84.0418 57.7174 84.2772Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3272 83.6025C59.333 82.4527 59.7017 81.0935 59.7017 80.0324L59.2515 80.0324C59.2515 81.5795 58.6618 82.7937 58.2126 83.5056C58.0313 83.793 58.1035 83.8582 58.3272 83.6025Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9659 12.6962C28.0829 12.6962 25.696 15.0838 25.696 17.9677H25C25 14.6993 27.6985 12 30.9659 12V12.6962Z",
    fill: "black",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0839 13.7228C28.2563 12.5444 29.5957 12.0994 30.966 12.0994V12.4972C29.2775 12.4972 27.9283 13.2822 27.1817 13.8267C26.9133 14.0224 26.8496 13.9582 27.0839 13.7228Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4741 14.3978C25.4682 15.5475 25.0996 16.9067 25.0996 17.9678L25.5498 17.9678C25.5498 16.4208 26.1395 15.2065 26.5887 14.4946C26.77 14.2072 26.6978 14.1421 26.4741 14.3978Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8354 12.6962C56.7184 12.6962 59.1052 15.0838 59.1052 17.9677H59.8013C59.8013 14.6993 57.1028 12 53.8354 12V12.6962Z",
    fill: "black",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7174 13.7228C56.545 12.5444 55.2055 12.0994 53.8353 12.0994V12.4972C55.5238 12.4972 56.873 13.2822 57.6196 13.8267C57.888 14.0224 57.9517 13.9582 57.7174 13.7228Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3272 14.3978C59.333 15.5475 59.7017 16.9067 59.7017 17.9678L59.2515 17.9678C59.2515 16.4208 58.6618 15.2065 58.2126 14.4946C58.0313 14.2072 58.1035 14.1421 58.3272 14.3978Z",
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 23.4382,
    width: 0.696023,
    height: 0.795699,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 0.696023,
    height: 0.7957,
    transform: "matrix(1 0 0 -1 25 78.5404)",
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 59.105,
    y: 23.4382,
    width: 0.696022,
    height: 0.795699,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 0.696022,
    height: 0.7957,
    transform: "matrix(1 0 0 -1 59.105 78.5404)",
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 42.0029,
    y: 12.6963,
    width: 0.696236,
    height: 0.795456,
    transform: "rotate(-90 42.0029 12.6963)",
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 0.696236,
    height: 0.795454,
    transform: "matrix(-4.3698e-08 1 1 4.37248e-08 46.1294 85.3038)",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_57_108)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.4004,
    cy: 16.078,
    rx: 1.09375,
    ry: 1.09409,
    fill: "#080808"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_57_108)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-28-inside-1_57_108",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.4003,
    cy: 16.078,
    rx: 0.596591,
    ry: 0.596774
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.4003,
    cy: 16.078,
    rx: 0.596591,
    ry: 0.596774,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9969 16.078C41.9969 15.8556 42.1772 15.6747 42.4003 15.6747V17.6747C43.2824 17.6747 43.9969 16.9596 43.9969 16.078H41.9969ZM42.4003 15.6747C42.6234 15.6747 42.8037 15.8556 42.8037 16.078H40.8037C40.8037 16.9596 41.5182 17.6747 42.4003 17.6747V15.6747ZM42.8037 16.078C42.8037 16.3004 42.6234 16.4812 42.4003 16.4812V14.4812C41.5182 14.4812 40.8037 15.1964 40.8037 16.078H42.8037ZM42.4003 16.4812C42.1772 16.4812 41.9969 16.3004 41.9969 16.078H43.9969C43.9969 15.1964 43.2824 14.4812 42.4003 14.4812V16.4812Z",
    fill: "white",
    fillOpacity: 0.1,
    mask: "url(#path-28-inside-1_57_108)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.4005,
    cy: 16.0779,
    rx: 0.497159,
    ry: 0.497312,
    fill: "url(#paint0_linear_57_108)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5555 16.3327C42.6413 16.2803 42.6985 16.1858 42.6985 16.0779C42.6985 15.9131 42.565 15.7795 42.4002 15.7795C42.2924 15.7795 42.1979 15.8368 42.1455 15.9226C42.1907 15.8949 42.2439 15.879 42.3008 15.879C42.4656 15.879 42.5991 16.0126 42.5991 16.1774C42.5991 16.2343 42.5832 16.2875 42.5555 16.3327Z",
    fill: "url(#paint1_linear_57_108)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1283 15.9553C42.1114 15.9927 42.1021 16.0343 42.1021 16.078C42.1021 16.2428 42.2356 16.3764 42.4003 16.3764C42.4441 16.3764 42.4856 16.367 42.523 16.3501C42.3348 16.2921 42.1862 16.1436 42.1283 15.9553Z",
    fill: "url(#paint2_linear_57_108)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_57_108",
    x: 41.3066,
    y: 14.9839,
    width: 2.1875,
    height: 3.18823,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_57_108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_57_108",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_57_108"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_57_108",
    x: 41.8037,
    y: 15.4812,
    width: 1.19336,
    height: 2.1936,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_57_108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_57_108",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_108",
    x1: 42.7485,
    y1: 15.7298,
    x2: 42.102,
    y2: 16.3761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_57_108",
    x1: 42.6074,
    y1: 15.8501,
    x2: 42.2122,
    y2: 16.2452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A54AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_57_108",
    x1: 42.6092,
    y1: 15.8691,
    x2: 42.2213,
    y2: 16.2569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.b163a390c6e9c00ca6c511c406631b1c.svg";
export { ForwardRef as ReactComponent };